<template>
    <div class="notices">
        <p-header title="重要通知"/>
        <div class="list">
            <component v-for="notice in notices" :is="notice.data.template" :notice="notice" :key="notice.id" />
        </div>
    </div>
</template>

<script>
    import header from './components/Header';
    import { mapGetters, mapActions } from 'vuex';
    import Normal from "./components/notice/Normal";
    import PaymentBlocking from "./components/notice/PaymentBlocking";
    import PaymentChange from "./components/notice/PaymentChange";
    import PaymentRefund from "./components/notice/PaymentRefund";
    import PaymentError from "./components/notice/PaymentError";
    import PaymentOwed from "./components/notice/PaymentOwed";
    import RecommendGift from "./components/notice/RecommendGift";

    export default {
        name: 'Notices',
        components: {
            'p-header': header,
            'payment-blocking': PaymentBlocking,
            'payment-change': PaymentChange,
            'payment-refund': PaymentRefund,
            'payment-error': PaymentError,
            'payment-error-refund': PaymentRefund,
            'payment-error-change': PaymentChange,
            'payment-owed': PaymentOwed,
            'recommend-gift': RecommendGift,
            'normal': Normal,
        },
        computed: {
            ...mapGetters(['notices'])
        },
        methods: {
            init() {
                this.getNotices();
            },
            ...mapActions(['getNotices'])
        },
        created() {
            this.init();
        },
    };
</script>

<style lang="scss" scoped>
    .notices {
        .list {
            margin: 15px;
        }
    }
</style>
